// extracted by extract-css-chunks-webpack-plugin
module.exports = {"relatedSearchWrapper":"pII-F","resultSet":"_5yUE6","searchLinks":"QDVMr","linkWrapper":"VGFPw","searchTextEllipsis":"_5-rtz"};